
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AppMovilService } from 'src/app/services/app-movil.service';
import { FormBuilder, FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from 'src/app/services/loader.service';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { filter, switchMap } from 'rxjs/operators';
import { MapUtils } from 'src/app/shared/utils/map-utils';

@Component({
  selector: 'filtro-fotos-capas',
  templateUrl: './filtro-fotos-capas.component.html',
  styleUrls: ['./filtro-fotos-capas.component.scss']
})
export class FiltroFotosCapasComponent implements OnInit, OnDestroy {

  @ViewChild('galeria')
  public modal: any;
  public modalActivo: NgbModalRef;
  public modalOption: NgbModalOptions = {};
  public estados$: Observable<any[]>;
  public obras$: Observable<any[]>;
  public licitaciones$: Observable<any[]>;
  public form: FormGroup;
  public fotos: any[];
  public filtroFotos: any[] = [];
  public mostrarMensajeSinFotos: boolean = false;
  public suscripcionFotos: Subscription;
  public indice: number = 0;
  public panelWidth: number = 0;
  public panelHeight: number = 0;

  // public polylinesProceso: GooglePolyline[] = null;
  // public polylinesTerminado: GooglePolyline[] = null;
  // public polylinesProblematica: GooglePolyline[] = null;
  // public polylineProyecto: GooglePolyline = null;

  public map: any;

  public capaProyectoSeleccionada: boolean = true;
  public capaEstructuraSeleccionada: boolean = true;
  public capaProcesoSeleccionada: boolean = true;
  public capaTerminadoSeleccionada: boolean = true;
  public capaProblematicaSeleccionada: boolean = true;

  constructor(
    private mapUtls: MapUtils,
    private dateUtils: DateUtils,
    private loaderScreenService: LoaderService,
    private ngbModalService: NgbModal,
    private appMovilService: AppMovilService,
    private formBuilder: FormBuilder) { }

  public ngOnInit(): void {
    this.inicializarForm();
    this.obtenerEstados();
    this.calcularTamanioPanelGaleria();
  }

  public calcularTamanioPanelGaleria() {
    this.panelWidth = window.innerWidth * .6;
    this.panelHeight = window.innerHeight * .65;
  }

  public inicializarForm(): void {
    this.form = this.formBuilder.group({
      estado: new FormControl('-1', [Validators.required, this.validateId]),
      obra: new FormControl('-1', [Validators.required, this.validateId]),
      licitacion: new FormControl('-1', [Validators.required, this.validateId]),
    });

    this.obras$ = this.form.get('estado').valueChanges.pipe(
      filter((keyEstado: string) => keyEstado !== '-1'),
      switchMap((keyEstado: string) => this.appMovilService.obtenerObrasTemporalesByEstado(keyEstado))
    );

    this.licitaciones$ = this.form.get('obra').valueChanges.pipe(
      filter((keyObra: string) => keyObra !== '-1'),
      switchMap((keyObra: string) => {
        let keyEstado: string = this.form.get('estado').value;
        return this.appMovilService.obtenerLicitacionesTemporalesByObra(keyEstado, keyObra)
      })
    );
  }

  public obtenerEstados(): void {
    this.estados$ = this.appMovilService.obtenerCatalogoEstados();
  }

  private validateId(control: AbstractControl) {
    return control.value === '-1' ? { error: 'El campo es requerido' } : null;
  }

  public getErrorFicha(controlName: string): string {
    let error = '';
    const control = this.form.get(controlName);
    if (control.touched && control.errors != null) {
      error = "El campo es requerido";
    }
    return error;
  }

  public abrirGaleriaFotos() {
    this.loaderScreenService.activarLoaderScreen();
    let estadoKey: string = this.form.get('estado').value;
    let obraKey: string = this.form.get('obra').value;
    let licitacionKey: string = this.form.get('licitacion').value;
    this.suscripcionFotos = this.appMovilService.obtenerFotosPorLicitacion(estadoKey, obraKey, licitacionKey).subscribe(
      (objetosFotos: any[]) => {
        if (objetosFotos.length > 0) {
          this.fotos = objetosFotos.map(
            objetoFoto => {
              return {
                source: objetoFoto.ruta,
                alt: objetoFoto.desc,
                title: this.dateUtils.obtenerFechaConFormato(new Date(objetoFoto.fecha)),
                nombreCapa: objetoFoto.nombreCapa,
                lat: objetoFoto.lat,
                lng: objetoFoto.lng
              }
            }
          )
          this.filtroFotos = [...this.fotos];
          this.mostrarMensajeSinFotos = false;
          this.modalActivo = this.ngbModalService.open(this.modal, { size: 'lg', centered: true, windowClass: 'modal-galeria', backdrop: "static", keyboard: false });
          this.modalActivo.result.then((result) => {
            // this.polylineProyecto = null;
            // this.polylinesProblematica = null;
            // this.polylinesProceso = null;
            // this.polylinesTerminado = null
            this.map = null;
          });
        } else {
          this.mostrarMensajeSinFotos = true;
        }
        this.loaderScreenService.desactivarLoaderScreen();
      }
    );
  }

  public seleccionarCapa(event: any, nombreCapaSeleccionada: any) {
    if (event) {
      this.filtroFotos = this.filtroFotos.concat(this.fotos.filter(f => f.nombreCapa === nombreCapaSeleccionada));
    } else {
      this.filtroFotos = this.filtroFotos.filter(f => f.nombreCapa !== nombreCapaSeleccionada);
    }
    this.indice = 0;
  }

  public obtenerNombreCapa(nombreCapa: string): string {
    if (nombreCapa === 'Avance') return 'En proceso';
    if (nombreCapa === 'AvanceFull') return 'Terminado';
    if (nombreCapa === 'Estructura') return 'Estructura';
    if (nombreCapa === 'Problema') return 'Problemática';
    if (nombreCapa === 'proyecto') return 'Proyecto';
  }

  public cambioImagen(event: any) {
    this.indice = event.index;
  }

  public mapReady(event: any): void {
    this.map = event;
    let estado = this.form.get('estado').value;
    let obra = this.form.get('obra').value;
    let licitacion = this.form.get('licitacion').value;
    // this.appMovilService.obtenerPolylineProyecto('appPruebas',estado, obra, licitacion).subscribe(
    //   (polylineProyecto: GooglePolyline) => {
    //     this.polylineProyecto = polylineProyecto;
    //     this.mapUtls.centrarPolyline(this.map, polylineProyecto);
    //   }
    // );
    // this.appMovilService.obtenerPolylinePorCapa('appPruebas',estado, obra, licitacion, 'Avance').subscribe(
    //   (polylinesProceso: GooglePolyline[]) => {
    //     this.polylinesProceso = polylinesProceso;
    //   }
    // );
    // this.appMovilService.obtenerPolylinePorCapa('appPruebas',estado, obra, licitacion, 'AvanceFull').subscribe(
    //   (polylinesTerminado: GooglePolyline[]) => {
    //     this.polylinesTerminado = polylinesTerminado;
    //   }
    // );
    // this.appMovilService.obtenerPolylinePorCapa('appPruebas',estado, obra, licitacion, 'Problema').subscribe(
    //   (polylinesProblematica: GooglePolyline[]) => {
    //     this.polylinesProblematica = polylinesProblematica;
    //   }
    // );
    this.capaProyectoSeleccionada = true;
    this.capaEstructuraSeleccionada = true;
    this.capaProcesoSeleccionada = true;
    this.capaTerminadoSeleccionada = true;
    this.capaProblematicaSeleccionada = true; 
  }

  // public centrarPolyline(polyline: GooglePolyline) {
    // this.mapUtls.centrarPolyline(this.map, polyline);
  // }

  // public centrarArregloPolylines(polylines: GooglePolyline[]) {
    // this.mapUtls.centrarArregloDePolylines(this.map, polylines);
  // }

  public centrarMarker(lat: number, lng: number) {
    this.mapUtls.centrarMarker(this.map, lat, lng);
  }

  public ngOnDestroy(): void {
    if (this.suscripcionFotos) {
      this.suscripcionFotos.unsubscribe();
    }
  }

}
